var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResponsiveLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6719 10.1641H21.1776L16.4307 18.5679L21.1776 26.9723H30.6719L35.4188 18.5679L30.6719 10.1641Z",
    fill: "#2B6BE6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.79965 19.4961L0.0527344 27.9004L4.79965 36.3048H14.2935L19.0404 27.9004L14.2935 19.4961H4.79965Z",
    fill: "#2B6BE6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2935 17.504L19.0404 9.09966L14.2935 0.695312H4.79965L0.0527344 9.09966L4.79965 17.504H14.2935Z",
    fill: "#2B6BE6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResponsiveLogo);
export default __webpack_public_path__ + "static/media/responsiveLogo.fd349169a064439454b3cd2c6009aae3.svg";
export { ForwardRef as ReactComponent };